<div class="breadcrumbs">
  <div>/</div>
  <div>Governance</div>
  <div>/</div>
  <div class="hasLink" [routerLink]="['/data-catalogue']">Data Catalogues</div>
  <div>/</div>
  <div>Facilis Origin AIXM 5.1</div>
  <div>/</div>
  <div>Property: {{ propertyName }}</div>
</div>
<mat-toolbar class="toolbar-custom">
  <span>
    <h3>Property: {{ propertyName }}</h3>
  </span>
  <span class="toolbar-icon">
    <mat-icon
      color="warn"
      style="cursor: pointer"
      (click)="openAccessRightsDialog()"
      matTooltip="Access Control List"
      >lock</mat-icon
    >
    <img
      class="status-icon"
      src="assets/icons/list-status.svg"
      alt="status icon"
      matTooltip="Business Rules"
      [routerLink]="['/data-catalogue/business-rules']"
    />
    <mat-icon matTooltip="Save" color="primary" style="cursor: pointer" (click)="saveMetadata()">
      save
    </mat-icon>
  </span>
</mat-toolbar>

<mat-expansion-panel
  class="custom-panel"
  [expanded]="metadataExpanded"
  (opened)="metadataExpanded = true"
  (closed)="metadataExpanded = false"
>
  <mat-expansion-panel-header>
    <mat-panel-title><b>Metadata</b> </mat-panel-title>
  </mat-expansion-panel-header>

  <div class="metadata-content">
    <div class="metadata-item">
      <div class="metadata-key">Identifier:</div>
      <div class="metadata-value">{{ propertyVM?.id }}</div>
    </div>

    <div class="metadata-item">
      <div class="metadata-key">Catalogue item type:</div>
      <div class="metadata-value">Property</div>
    </div>

    <div class="metadata-item">
      <div class="metadata-key">Parent group:</div>
      <div class="metadata-value">
        <a
          href="/#/data-catalogue/{{catId}}/property-group/{{
            parentGroupName
          }}"
        >
          {{ parentGroupName }}
        </a>
      </div>
    </div>

    <div class="metadata-item">
      <div class="metadata-key"><b>Display name:</b></div>
      <div class="metadata-value"></div>
    </div>

    <div class="metadata-detailed-item">
      <div class="metadata-detail-key">English</div>
      <mat-form-field appearance="outline" class="full-width" *ngIf="!!propertyVM">
        <input matInput placeholder="" [(ngModel)]="propertyVM.displayName" />
      </mat-form-field>
    </div>

    <div class="metadata-item">
      <div class="metadata-key"><b>Description:</b></div>
      <div class="metadata-value"></div>
    </div>

    <div class="metadata-detailed-item">
      <div class="metadata-detail-key">English</div>
      <div class="metadata-deatil-value full-width-input">
        <mat-form-field appearance="outline" class="full-width" *ngIf="!!propertyVM">
          <textarea
            matInput
            placeholder="description"
            name="description"
            rows="4"
            [(ngModel)]="propertyVM.description"
          ></textarea>
        </mat-form-field>
      </div>
    </div>

    <div class="metadata-item">
      <div class="metadata-key">Last edited by:</div>
      <div class="metadata-value">{{ propertyVM?.author }}</div>
    </div>

    <div class="metadata-item">
      <div class="metadata-key">Last edited on:</div>
      <div class="metadata-value">
        {{ propertyVM?.timestamp | date : "dd MMM yyyy" }}
      </div>
    </div>
  </div>
</mat-expansion-panel>

<div class="content-container">
  <div class="tree-container">
    <div class="additional-info">
      <div class="additional-info-item" *ngIf="propertyVM">
        <div class="additional-info-key">
          <div *ngIf="propertyTypeName === 'dataTypeRef'">
            Data type:
            <a
              [routerLink]="[
                '/data-catalogue/data-type',
                propertyVM.propertyReference
              ]"
            >
              {{ propertyVM.propertyReference }}
            </a>
          </div>

          <div *ngIf="propertyTypeName === 'featureRef'">
            Feature reference:
              <a
              [routerLink]="[
                '/data-catalogue/2037172d-1390-4033-9017-e5424166927e/feature',
                propertyVM.propertyReference
              ]"
            >
              {{ propertyVM.propertyReference }}
            </a>
          </div>

          <div *ngIf="propertyTypeName === 'dataObjectRef'">
            Object:
            <a [routerLink]="'/data-catalogue/' + catId + '/object/' + propertyVM.propertyReference">
              {{ propertyVM.propertyReference }}
            </a>
          </div>
        </div>
        <div class="additional-info-value">
          {{ matchingProperty?._type.toString()?.substring(5) }}
        </div>
      </div>
      <!-- <div class="additional-info-item">
        <div class="additional-info-key">Feature type reference:</div>
        <div class="additional-info-value">
          <a href="/#/data-catalogue/feature/{{ featureName }}">
            {{ featureName }}
          </a>
        </div>
      </div>
      <div class="additional-info-item">
        <div class="additional-info-key">Property group:</div>
        <a
          href="/#/data-catalogue/feature/{{ featureName }}/property-group/{{
            propertyGroupName
          }}"
        >
          {{ propertyGroupName }}
        </a>
        <div class="additional-info-value"></div>
      </div> -->
    </div>
    <mat-slide-toggle
      [checked]="propertyVM?.airacRelated"
      (change)="onAiracToggle($event.checked)"
    >
      AIRAC related
    </mat-slide-toggle>

    <br />
    <br />
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header>
        <mat-panel-description>
          ICAO Aeronautical Information Catalog meta-properties
        </mat-panel-description>
      </mat-expansion-panel-header>

      <p>
        <b>Accuracy:</b>
        {{ propertyVM?.icao?.accuracyValue }}{{ propertyVM?.icao?.accuracyUom }}
      </p>
      <p>
        <b>Publication resolution (AIP):</b>
        {{ propertyVM?.icao?.aipResolutionValue
        }}{{ propertyVM?.icao?.aipResolutionUom }}
      </p>
      <p>
        <b>Publication resolution (charts):</b>
        {{ propertyVM?.icao?.chartResolutionValue
        }}{{ propertyVM?.icao?.chartResolutionUom }}
      </p>
    </mat-expansion-panel>
  </div>
  <div class="feature-info-container">
    <div class="info-title">
      <div class="official-data">Official Data</div>
      <div class="smaller">(effective {{ today }})</div>
    </div>
    <div class="occuriencies">Occurrences: {{ this.propertyCount }}</div>
  </div>
</div>
